<template lang="pug">
  header.hero.is-light
    .hero-head
      nav.navbar.is-primary.has-shadow(v-bind:class="{'is-warning': isHom}")
        .navbar-brand
          a.navbar-item.logo
            img(src='~@/assets/logo.png', alt='THEPES Logo' height="10")
          .navbar-warning(v-if="isHom")
            a.navbar-item HOMOLOGAÇÃO
          .navbar-burger.burger(@click="toggleMenuVisibility")
            span
            span
            span
        .navbar-menu.is-hidden-tablet(v-bind:class="{ 'is-active': menuShown }")
          a.navbar-item(@click="logout()") Desconectar
        .navbar-menu
          .navbar-end
            b-dropdown
              a(slot="trigger").navbar-item
                span {{$parent.user.name}}
                b-icon(icon="arrow_drop_down")

              b-dropdown-item.has-text-primary(@click="logout()") Desconectar
</template>

<script>
  import AuthService from '@/services/auth.js'

  export default {
    name: 'custom-header',
    data () {
      return {
        isHom: !!(process.env.IS_HOM),
        menuShown: false
      }
    },
    methods: {
      toggleMenuVisibility () {
        this.menuShown = !this.menuShown
      },
      logout () {
        AuthService.logout()
        .then(() => {
          this.$toast.open({
            message: 'Desconectado com sucesso.',
            type: 'is-success',
            duration: 5000
          })
          this.$router.push({name: 'Auth'})
        })
      }
    }
  }
</script>

<style lang="sass" scoped>
  @import "~@/assets/sass/common.sass"
  header
    .hero-head
      background: $main-bg
  .logo
    padding: 0.2rem 1rem
    img
      max-height: 2rem
  .navbar-warning
    display: flex
    flex-grow: 1
    justify-content: center
    align-self: center
  .navbar-item
    font-weight: bold
    &:hover
      background-color: $main-bg
</style>



// WEBPACK FOOTER //
// Header.vue?42613f8a